import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import GameScreen from './GameScreen';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  init() {
    this.titleSprite = null;
    this.title = null;
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(-17,-11,UIAssetKeys._background, this).setOrigin(0);

    const cover = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height / 2, UIAssetKeys._candy_box_cover, this).setScale(0.85);

    this.button = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width / 2 + 120, this.scale.height / 2 + 120, UIAssetKeys._go_button, null, null, () => this.cleanUp(), this, DEFAULT_BUTTON_CONFIG).setScale(0);

    ABCyaPhaser.Tweens.addTween(this.button, 1000, { delay: 200, scale: 1 }, Phaser.Math.Easing.Bounce.Out);

    this.titleSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._title, this.titleSound);
  }

  cleanUp () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.tweens.killAll();
    this.titleSound.destroy();
    this.titleSound = null;

    this.scene.start(GameScreen.KEY);
  }
}